import MuiDialogActions from "@mui/material/DialogActions";
const DialogActions = MuiDialogActions;
export default DialogActions;
